<photo-view
  *ngIf="mode === 'view'"
  [text]="text"
  [photoSrc]="photoSrc"
  [size]="size"
  [width]="width"
  [height]="height"
  [borderRadius]="borderRadius"
  [rounded]="rounded"
  [loading]="loading"
  [showPreview]="showPreview"
  (openPreviewDialog)="openPreviewDialog.emit()"
></photo-view>

<photo-edit
  *ngIf="mode === 'edit' || mode === 'create'"
  [newPhoto]="newPhoto"
  [photoSrc]="photoSrc"
  [size]="size"
  [width]="width"
  [height]="height"
  [borderRadius]="borderRadius"
  [rounded]="rounded"
  [loading]="loading"
  (photoChange)="photoChange.emit($event)"
  (photoDelete)="photoDelete.emit()"
></photo-edit>
